import { useTranslation } from "react-i18next";

export default function UserGuide() {
  const { i18n } = useTranslation();

  const src =
    i18n.language === "sv"
      ? "https://scribehow.com/page-embed/North_House_Anvandarguide__84fHlXdHRWigG3tVKF-czg"
      : "https://scribehow.com/page-embed/North_House_User_guide__ta7P9LFESXG-BdPmCd6v7g";

  return (
    <iframe
      src={src}
      width="100%"
      height="100%"
      allow="fullscreen"
      style={{
        border: "0",
        display: "flex",
        flex: 1,
        borderTop: "1px solid var(--border)",
      }}
    ></iframe>
  );
}
